<ng-container *transloco="let t; read: 'devices.detail.notes'">
  @if (vm$ | async; as vm) {
    <form [formGroup]="noteForm">
      <div class="fieldsetWrapper">
        <fieldset class="fieldsetContainer flexRow ">
          <div class="titleAdd">
            <h2 class="xs12col padding-right-small">{{ t('title') }}</h2>
            <button
              kendoButton
              class="addIcon small"
              (click)="openNoteDialog()">
              <span class="icon">
                <img src="../../../assets/icons/add-icon.svg">
              </span>
            </button>
          </div>
          @if (notesOpened) {
            <kendo-dialog
              title="{{ editingNote ? t('edit') : t('add') }}"
              (close)="closeNoteDialog('cancel')"
              [minWidth]="250"
              [width]="450"
              class="noteDialog">
              <form [formGroup]="noteForm">
                <kendo-formfield>
                  <kendo-label [for]="description" [text]="t('description')"></kendo-label>
                  <kendo-textarea
                    class="mbs"
                    [rows]="4"
                    formControlName="description"
                    #description>
                  </kendo-textarea>
                </kendo-formfield>
                <kendo-dialog-actions>
                  <button
                    [disabled]="noteForm.invalid || !noteForm.dirty"
                    type="submit"
                    kendoButton
                    (click)="submitNoteCreation()"
                    class="buttonPrimary">
                    {{ editingNote ? t('update') : t('submit') }}
                  </button>
                  <button
                    kendoButton
                    (click)="closeNoteDialog('no')"
                    class="buttonSecondary">
                    {{t('cancel')}}
                  </button>
                  <button
                    kendoButton
                    class="buttonSecondary"
                    (click)="removeNote()"
                    [hidden]="!editingNote">
                    <img src="../../../assets/icons/delete-icon.svg">
                  </button>
                </kendo-dialog-actions>
              </form>
            </kendo-dialog>
          }
          @for (note of vm.notes; track note) {
            <div class="xs12col noteWrapper">
              <div class="noteContainer">
                <div class="content">
                  <p>
                    {{ note.description }}
                  </p>
                </div>
                <div class="footer">
                  <div class="dates">
                    <span class="date"><img src="../../../assets/icons/calendar-icon.svg">{{ sanitizeCreationDate(note.createdOn) }}</span>
                    <span class="date"><img src="../../../assets/icons/profile-icon.svg"> {{ note.createrFirstName }} {{ note.createrLastName }}</span>
                  </div>
                  <button
                    kendoButton
                    class="buttonSecondary"
                    (click)="editNote(note)"
                    [disabled]="!isCreator(note)">
                    <img src="../../../assets/icons/edit-icon.svg">
                  </button>
                </div>
              </div>
            </div>
          }
        </fieldset>
      </div>
    </form>
  }
</ng-container>